import getHeaders from '@/api/headersSetting'

/**
* Funcão para salvar os parâmetro na store
*/
export function URLSearchParams () {
  const _params = {}
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    _params[key] = value
  })

  return {
    ...getHeaders(),
    ..._params
  }
}
